import React, { useRef, useEffect } from "react";
import logo from "../../assets/img/logo.svg";

export default function DailyTimeline({ missions }) {

    const scrollRef = useRef(null);

    useEffect(() => {
        const columnWidth = window.innerWidth * 0.05; // 5vw
        const eightAMColumn = 32;
        const scrollTo = eightAMColumn * columnWidth;

        if (scrollRef.current) {
            scrollRef.current.scrollLeft = scrollTo;
        }
    }, []);

    // Convertit "HH:mm" en numéro de quart d'heure
    function timeToQuarterIndex(time) {
        const [hours, minutes] = time.split(":").map(Number);
        return hours * 4 + Math.floor(minutes / 15);
    }

// Calcule la durée entre deux heures (en quarts d'heure)
    function getDuration(start, end) {
        return timeToQuarterIndex(end) - timeToQuarterIndex(start);
    }

    // On crée une map groupId → ligne
    const groupLines = {};
    let nextLine = 1;

    missions.forEach(m => {
        if (!groupLines[m.groupId]) {
            groupLines[m.groupId] = nextLine++;
        }
    });

    return (
        <div className="daily-timeline">
            <div className="timeline-informations">
                <div>
                    <h4>Missions en ce moment</h4>
                    <h3>Date</h3>
                </div>
                <div>
                    {/* truc pour sélectionner une date*/}
                    <input type={"date"} onChange={timeToQuarterIndex} />
                </div>
            </div>
            <div className="timeline-wrapper">
            {/* Ligne des heures */}
            <div className="timeline-hours">
                {[...Array(24)].map((_, hour) => (
                    <div key={hour} className="hour-block">
                        {hour.toString().padStart(2, "0")}:00
                    </div>
                ))}
            </div>

            {/* Grille des missions */}
            <div className="timeline-grid">
                {/* Alternance visuelle */}
                {[...Array(12)].map((_, i) => (
                    <div
                        key={i}
                        className="background-block"
                        style={{
                            gridColumn: `${i * 8 + 1} / span 4`,
                            gridRow: `${nextLine} / -1`, // s'étend sur toutes les lignes
                        }}
                    />
                ))}

                {missions.map((mission, i) => {
                    const start = timeToQuarterIndex(mission.start);
                    const duration = getDuration(mission.start, mission.end);
                    const row = groupLines[mission.groupId];

                    return (
                        <article
                            key={i}
                            className="mission-card"
                            style={{
                                gridColumn: `${start + 1} / span ${duration}`,
                                gridRow: row,
                            }}
                        >
                            <div className={"offer-gradient-bar"}></div>
                            <div>
                            <h4 className="role">{mission.role}</h4>
                            <div className="time">{mission.start} - {mission.end}</div>
                            </div>
                            <div className="place">
                                <img src={logo} alt="" />
                            <p>    {mission.place} </p>
                            </div>
                        </article>
                    );
                })}
            </div>
        </div>
    </div>

    );
}